import { Value } from '../1-building-info/building-info.types';

export type Room = {
  id: string;
  number: number;
  label: string;
  width: number;
  spaceFunctionId: string;
  length: Value;
  isVariableLength: boolean;
};

export type LayoutRow = {
  numberOfRooms: number;
  width: number;
  rooms: Room[];
};

export type Layout = {
  rowFirst: LayoutRow;
  corridor: any;
  rowSecond: LayoutRow;
};

export const createFieldId = (roomId: string, field: string) =>
  `${roomId}.${field}`;
export const createRoomLabel = (rowNumber: number, roomNumber: number) =>
  `R ${rowNumber}.${roomNumber + 1}`;
export const createRoomId = (rowNumber: number, roomNumber: number) =>
  `rooms[${roomNumber}]`;
